import React from 'react';

class CallToAction extends React.Component {
  render () {
    return (
      <div className='callToAction'>
        <div className='powered-by'>BUILD YOUR OWN GRAPHQL CONTENT API WITH</div>
        <div style={{ marginTop: 'auto'}}><a href='https://graphcms.com/' target='_blank'><img className='graphcms-logo' alt='GraphCMS Logo' src={require('./asset/graphcms-logo.svg')} /></a></div>
      </div>
    );
  }
}

export default CallToAction;



// WEBPACK FOOTER //
// ./src/CallToAction.js